import { CSSProperties, FC } from 'react';
import ReactQRCode from 'react-qr-code';

export const QRCode: FC<{ value: string; size?: number; style?: CSSProperties }> = ({
  value,
  size = 256,
  style,
}) => {
  const { background = 'white', padding = '16px', ...styleProperties } = style ?? {};
  return (
    <div style={{ background, padding, ...styleProperties }}>
      <ReactQRCode
        size={size}
        style={{ height: 'auto', maxWidth: '100%', width: '100%', display: 'block' }}
        value={value}
        viewBox={`0 0 ${size} ${size}`}
      />
    </div>
  );
};
